import API from '../../clients/api'
import PROFILE from '../../clients/profile'
import { errorHandler } from '../helpers'

const fetchBookmarksByCourse = async userId => {
  const route = `bookmarks?user_id=${userId}&embed=course,video&number=1000`
  return API.get(route)
    .then(response => Promise.resolve(response.data.data))
    .catch(error => Promise.reject(errorHandler(error.response.data)))
}

const bookmarkVideo = async bookmark => {
  const route = `bookmarks`
  return API.post(route, bookmark)
    .then(response => Promise.resolve(response.data.data))
    .catch(error => Promise.reject(errorHandler(error.response.data)))
}

const removeBookmark = async id => {
  const route = `bookmarks/${id}`
  return API.delete(route)
    .then(response => Promise.resolve(response.data.data))
    .catch(error => Promise.reject(errorHandler(error.response.data)))
}

const fetchAllUserCourseProgress = async userId => {
  const route = `users/${userId}/progress`
  return API.get(route)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(errorHandler(error.response.data)))
}

const fetchUserCourseProgress = async userAndCourseId => {
  const { userId, courseId } = userAndCourseId
  const route = `users/${userId}/progress/course/${courseId}`
  return API.get(route)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(errorHandler(error.response.data)))
}

const fetchUserActiveCourses = async userId => {
  const route = `users/${userId}/courses?active&embed=progress,presenter,track.vendor&number=1000`
  return API.get(route)
    .then(response => Promise.resolve(response.data.data))
    .catch(error => Promise.reject(errorHandler(error.response.data)))
}

const addUserActiveCourse = async userAndCourseId => {
  const { userId, courseId: course_id } = userAndCourseId
  const route = `users/${userId}/courses`
  return API.put(route, { course_id })
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(errorHandler(error.response.data)))
}

const removeUserActiveCourse = async userAndCourseId => {
  const { userId, courseId } = userAndCourseId
  const route = `users/${userId}/course/${courseId}`
  return API.delete(route)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(errorHandler(error.response.data)))
}

const addUserWatchedVideo = async userAndVideoId => {
  const { userId, vidId: video_id } = userAndVideoId
  const route = `users/${userId}/video`
  return API.put(route, { video_id })
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(errorHandler(error.response.data)))
}

const removeUserWatchedVideo = async userAndVideoId => {
  const { userId, vidId } = userAndVideoId
  const route = `users/${userId}/video/${vidId}`
  return API.delete(route)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(errorHandler(error.response.data)))
}

const fetchUserLearningPathProgress = async userAndPathId => {
  const { userId, pathId } = userAndPathId
  const route = `users/${userId}/progress/paths/${pathId}`
  return API.get(route)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(errorHandler(error.response.data)))
}

const fetchUserLearningPathResume = async userAndPathId => {
  const { userId, pathId } = userAndPathId
  const route = `users/${userId}/paths/${pathId}/resume`
  return API.get(route)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(errorHandler(error.response.data)))
}

const fetchUserActiveSubscriptions = async memberId => {
  const route = `user-subscriptions/${memberId}`
  return API.get(route)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(errorHandler(error.response.data)))
}

const fetchSampleAvatars = async () => {
  const route = `users/avatar/default?number=all`
  return PROFILE.get(route)
    .then(response => Promise.resolve(response.data.data))
    .catch(error => Promise.reject(errorHandler(error.response.data)))
}

const postUserAvatar = async fileAndType => {
  const { file, type } = fileAndType

  const formData = new FormData()
  switch (type) {
    case 'binary':
      formData.append('user_avatar', file)
      break
    case 'base64':
      formData.append('base64_avatar', file)
      break
    default:
      formData.append('user_avatar', file)
      break
  }

  const route = `users/avatar`
  return PROFILE.post(route, formData)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(errorHandler(error.response.data)))
}

export {
  addUserActiveCourse,
  removeUserActiveCourse,
  fetchUserActiveCourses,
  bookmarkVideo,
  fetchBookmarksByCourse,
  removeBookmark,
  fetchAllUserCourseProgress,
  fetchUserCourseProgress,
  addUserWatchedVideo,
  removeUserWatchedVideo,
  fetchUserLearningPathProgress,
  fetchUserLearningPathResume,
  fetchUserActiveSubscriptions,
  fetchSampleAvatars,
  postUserAvatar,
}
